import { getSidebarPages } from '@/config/pages';
import { useGetStudiesListQuery } from '@/state/slices/studies';
import { SidebarNavItem } from './SidebarNavItem';
import styles from './Sidebar.module.css';

export function SidebarNav() {
  const sidebarPages = getSidebarPages();

  const { data: pendingData } = useGetStudiesListQuery({
    is_assigned: true,
    report_status: ['DRAFT', 'PRELIMINARY'],
    size: 1,
  });
  const pendingCount = pendingData?.count ?? 0;

  return (
    <nav className={styles.nav} aria-label="Main navigation">
      {sidebarPages.map((page) => (
        <SidebarNavItem
          key={page.id}
          page={page}
          badge={page.id === 'studies' ? pendingCount : undefined}
        />
      ))}
    </nav>
  );
}
